import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  markdown?: string;
}

function MarkdownWidget({ instance }: WidgetRenderProps<Config>) {
  const md = instance.config.markdown ?? '# Markdown Widget\n\nEdit me in settings.';
  return (
    <div style={{ height: '100%', overflow: 'auto', padding: 4 }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
    </div>
  );
}

export const markdownWidgetDef: WidgetDefinition<Config> = {
  type: 'markdown',
  name: 'Markdown',
  description: 'Rich text notes',
  icon: 'FileMarkdownOutlined',
  category: 'content',
  defaultTitle: 'Notes',
  defaultConfig: { markdown: '# Hello\n\nSome **markdown** content.' },
  minW: 2,
  minH: 3,
  defaultW: 4,
  defaultH: 4,
  component: MarkdownWidget,
  settingsSchema: {
    fields: [{ key: 'markdown', label: 'Markdown content', type: 'textarea' }],
  },
};
